import React, { useMemo } from 'react';
import { prop } from 'ramda';
import { useDeviceSelector, useGameConfigurationSelector } from 'js/store/hooks';
import { ManagedPopup } from 'js/components/common/Popup';
import { Game as CommonGame } from 'js/components/common/Game';
import { useOnClose } from 'js/components/common/PopupManager';
import { DISPLAY_MODE, GAME_SIZES } from 'js/components/common/GamesView/constants';
import GridPagingSlider from 'js/components/common/GamesView/GridPagingSlider';
import { WebContentInner } from 'js/components/system/WebContent';
import { useTranslations } from 'js/hooks/i18n';
import { useFormatter } from 'js/hooks/useFormatter';

import * as constants from './constants';

import style from './FreeSpin2BonusGamesPopup.scss';

const Game = (props) => <CommonGame {...props} showTitle={true} container="post-bonus-popup" />;

export const FreeSpin2BonusGamesPopup = ({
    id,
    title,
    controls,
    gameCodeNames,
    selectedBetConfiguration
}) => {
    const formatter = useFormatter();
    const t = useTranslations('playtech.mobile.system.fs2.popup.');
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const games = useGameConfigurationSelector(prop('games'));
    const selectedGames = gameCodeNames.filter(gameCode => games?.[gameCode]) || [];
    const onClose = useOnClose(id);
    const buttons = [
        {
            text: 'playtech.mobile.system.popup.okButton',
            onClick: onClose,
            className: style.btn
        }
    ];
    const message = useMemo(() => {
        const fsPrice = formatter.formatCurrency(selectedBetConfiguration.betValue.amount, {
            currencyCode: selectedBetConfiguration.betValue.amount.currencyCode
        });

        return t('accepted', [selectedBetConfiguration.initialCount, fsPrice], '{0} {1}');
    }, [
        selectedBetConfiguration,
        formatter,
        t
    ]);

    return (
        <ManagedPopup
            id={id}
            title={title}
            layerClassNames={style}
            controls={controls}
            buttons={buttons}
        >
            <WebContentInner className={style.description} content={message} />
            <GridPagingSlider
                Game={Game}
                swipe={!isDesktop}
                gamesPerSlideMin={1}
                fillLastSlide={false}
                showFeatureIcons={false}
                gameCodes={selectedGames}
                showControlsOnHover={false}
                displayMode={DISPLAY_MODE.PAGING}
                gameSize={GAME_SIZES.EXTRA_SMALL}
                classNames={{ game: style.game }}
                sliderOptions={constants.SLIDER_OPTIONS_MINI}
                container="post-bonus-popup"
            />
        </ManagedPopup>
    );
};
